// hack for babel-plugin-component

export { default } from '../wxc-tab-page/full-page.vue';



// WEBPACK FOOTER //
// ./packages/wxc-full-page/index.js